import React, { useState, useEffect } from 'react';
import {
  Box,
  Heading,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  Icon,
  Spinner,
} from '@chakra-ui/react';
import { FiUsers, FiRefreshCw, FiMail, FiKey } from 'react-icons/fi';
import { tenantHeaders } from '../tenant';

const API_BASE = '/api/v1';

function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const getAuthHeaders = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Token ${localStorage.getItem('token')}`,
    ...tenantHeaders(),
  });

  useEffect(() => {
    fetch(`${API_BASE}/dashboard/`, { headers: getAuthHeaders() })
      .then(res => res.json())
      .then(data => {
        setStats(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return <Box textAlign="center" py={20}><Spinner size="xl" color="orange.500" /></Box>;
  }

  const StatCard = ({ icon, label, value, helpText, color }) => (
    <Box bg="white" p={6} borderRadius="lg" boxShadow="md">
      <Stat>
        <Box display="flex" alignItems="center" mb={2}>
          <Icon as={icon} boxSize={6} color={color} mr={2} />
          <StatLabel fontSize="md" color="gray.500">{label}</StatLabel>
        </Box>
        <StatNumber fontSize="3xl" color="gray.700">{value}</StatNumber>
        <StatHelpText color="gray.400">{helpText}</StatHelpText>
      </Stat>
    </Box>
  );

  return (
    <Box>
      <Heading size="lg" mb={6}>Dashboard</Heading>
      
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6}>
        <StatCard
          icon={FiUsers}
          label="Total Contacts"
          value={stats?.total_contacts || 0}
          helpText={`${stats?.recent_contacts || 0} new this month`}
          color="orange.500"
        />
        <StatCard
          icon={FiRefreshCw}
          label="Sync Runs"
          value={stats?.total_sync_runs || 0}
          helpText={`${stats?.recent_sync_runs || 0} this month`}
          color="green.500"
        />
        <StatCard
          icon={FiMail}
          label="Webhooks"
          value={stats?.total_webhooks || 0}
          helpText={`${stats?.recent_webhooks || 0} this month`}
          color="blue.500"
        />
        <StatCard
          icon={FiKey}
          label="Active API Keys"
          value={stats?.active_api_keys || 0}
          helpText="Currently active"
          color="purple.500"
        />
      </SimpleGrid>
    </Box>
  );
}

export default Dashboard;
